export enum SortLeaveRequestField {
  START_DATE = 'start_date',
}
